import clsx from 'clsx';
import { ReactNode } from 'react';

import Chevron from '~/shared/assets/icons/chevron.svg';

export default function TablePagination({
  totalPages,
  currentPage,
  goToPage,
}: {
  currentPage: number;
  goToPage: (num: number) => void;
  totalPages: number;
}) {
  console.log({ currentPage, totalPages });

  return (
    <div className="flex items-center gap-[4px] justify-center min-h-[32px]">
      <Chevron
        onClick={() => goToPage(currentPage - 1)}
        className={clsx(
          'w-5 h-5 rotate-90',
          currentPage === 0 ? 'fill-[#949EAC5C] pointer-events-none' : 'fill-black cursor-pointer'
        )}
      />

      {[0, 1, 2]
        .filter((p) => p < totalPages)
        .map((p) => (
          <PaginationItem key={p} onClick={() => goToPage(p)} active={p === currentPage}>
            {p + 1}
          </PaginationItem>
        ))}

      {totalPages > 3 && (
        <>
          <PaginationItem active={false}>...</PaginationItem>

          {currentPage > 2 && totalPages !== currentPage + 1 && (
            <>
              <PaginationItem active={true}>{currentPage + 1}</PaginationItem>{' '}
              <PaginationItem active={false}>...</PaginationItem>
            </>
          )}

          <PaginationItem
            onClick={() => goToPage(totalPages - 1)}
            active={totalPages - 1 === currentPage}
          >
            {totalPages}
          </PaginationItem>
        </>
      )}
      <Chevron
        onClick={() => goToPage(currentPage + 1)}
        className={clsx(
          'w-5 h-5 rotate-[-90deg]',
          currentPage === totalPages - 1
            ? 'fill-[#949EAC5C] pointer-events-none'
            : 'fill-black cursor-pointer'
        )}
      />
    </div>
  );
}

function PaginationItem({
  children,
  active,
  onClick,
}: {
  children: ReactNode;
  active: boolean;
  onClick?: VoidFunction;
}) {
  return (
    <div
      onClick={onClick}
      className={clsx(
        'text-[13px] leading-[20px] w-[32px] h-[32px] flex items-center justify-center text-center rounded-full',
        active ? 'text-white bg-primary-300' : 'text-[#949EAC]',
        typeof children !== 'number' ? 'cursor-default' : !active ? 'cursor-pointer' : ''
      )}
    >
      {children}
    </div>
  );
}
